import React, { useMemo, useState } from "react";
import SimpleModal from "../../../SimpleModal";
import "./index.css";
import { withRouter } from "react-router-dom";
import "../../StatusModal/modal.css";
import FullScreenSpinner from "../../../../global/components/FullScreenSpinner";
import { ReactTable } from "../../ReactTable";

import { GET_LINKING_790A_PAGINATED_DATA } from "../../../../screens/Cases/queries";
import { client } from "../../../..";
import { caseLookupColumns } from "./columns/caseLookupColumns";
import { useDebounce } from "../../../Hooks";

export function LookupTableModal({
  sendToAcknowledge,
  showModal,
  setOwner,
  isV2,
  isLinking,
  caseOne,
  selectedCase,
  setSelectedCase,
  toggleModal,
  user_id,
  groupRole,
  group_id,
  isEmergency,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm);
  const [casesForLinking, setCasesForLinking] = useState([]);
  const [casesForLinkingLoading, setCasesForLinkingLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const queryParameters = {
    UISorting: {
      type: "Linkable790A",
      formVersionId: isV2 ? 2 : 3,
      form_id: "9142A",
      caseType: "790A",
      limit: 10,
      page: 0,
      sort_ascending: 0,
      sort_column: "dateSubmitted",
      is_emergency: isEmergency?.toUpperCase() === "YES" ? 1 : 0,
    },
    UISearch: {
      search: "",
    },
    getCasesInput: {
      user_id,
      groupRole: groupRole || null,
      group_id: group_id || null,
    },
  };

  const fetchData = async ({ pageSize, pageIndex, sortBy, searchTerm }) => {
    setCasesForLinkingLoading(true);
    queryParameters.UISorting.page = pageIndex;
    queryParameters.UISorting.limit = pageSize;
    queryParameters.UISorting.sort_ascending = sortBy[0]?.desc ? 1 : 0;
    queryParameters.UISorting.sort_column = sortBy[0]?.id;
    queryParameters.UISearch.search = searchTerm;
    let query_params = queryParameters;
    client
      .query({
        query: GET_LINKING_790A_PAGINATED_DATA,
        variables: query_params,
        fetchPolicy: "no-cache",
      })
      .then((response) => {
        const { data, loading, error } = response;

        if (!error && !loading && data) {
          const dataTotalCount = data?.getPaginatedData?.total_count;
          setCasesForLinking(data?.getPaginatedData?.LinkableCases);
          setPageCount(Math.ceil(dataTotalCount / pageSize));
          setCasesForLinkingLoading(false);
        }
      });
  };

  const handleSelect = (e, owner) => {
    setSelectedCase(e.target.value);
    setOwner(owner);
  };
  const memoizedColumns = useMemo(
    () =>
      caseLookupColumns({
        selectedCase,
        caseOne,
        handleSelect,
      }),
    [casesForLinking, selectedCase]
  );

  return (
    <SimpleModal
      modalStatus={showModal}
      minWidth={"90%"}
      renderButton={() => null}
      toggleModal={toggleModal}
    >
      <div>
        {isLinking && <FullScreenSpinner />}
        <div className={"case-lookup-heading"}>
          <h3>Job Order Lookup</h3>
        </div>
        <p>
          Locate the completed job order (Form ETA-790/790A) satisfying the
          requirements at 20 CFR 653, subpart F, and 20 CFR 655.122 below. *
        </p>
        <div className={"job-order-search-form"}>
          <input
            type={"text"}
            placeholder={"Type search term here..."}
            id={"job-order-search"}
            onChange={(e) => setSearchTerm(e.target.value.toUpperCase())}
          />
          <button
            type="button"
            className={"usa-button usa-button usa-button-primary"}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Search
          </button>
          <button
            type="button"
            className={"reset-button"}
            onClick={(e) => {
              document.getElementById("job-order-search").value = "";
              setSearchTerm("");
            }}
          >
            Reset
          </button>
        </div>
        <ReactTable
          loading={casesForLinkingLoading}
          showPagination={true}
          tableStyle={{ marginTop: 25 }}
          data={casesForLinking}
          fetchData={fetchData}
          pageCount={pageCount}
          searchTerm={debouncedSearchTerm}
          striped
          defaultSortBy={[
            {
              id: "dateSubmitted",
              desc: false,
            },
          ]}
          columns={memoizedColumns}
        />
        <button
          className={"usa-button usa-button-primary modal-submit"}
          disabled={!selectedCase}
          type="button"
          onClick={sendToAcknowledge}
        >
          Submit
        </button>
      </div>
    </SimpleModal>
  );
}

export default withRouter(LookupTableModal);
